import React, { useState } from "react";
import API from '../../../redux/api';
import DialogBox from '../../../Components/common/dialog';
import { commonToast } from "../../../Components/common";

const SwitchStatusDialog = ({ id, status, isOpen, setSwitchDialog, onSuccess }) => {
  // Local State
  const [isDisableConfirm, setIsDisableConfirm] = useState(false);

  const statusSwitch = status === 'Active' ? 'Inactive' : 'Active';
  
  const handleClose = () => {
    setSwitchDialog({ id: '', status: '', isOpen: false });
  };

  const handleConfirm = async () => {
    setIsDisableConfirm(true);
    const response = await API.patch(`users/users_api/user/${id}/`, {
      id: id,
      status: statusSwitch,
    });
    
    setIsDisableConfirm(false);
    handleClose();

    if (response.status === 200) {
      commonToast("success", 'User status updated successfully');
      if (typeof onSuccess === 'function') {
        try {
          onSuccess(id, statusSwitch);
        } catch (_) {
          // no-op
        }
      }
    } else {
      commonToast("error", 'Error updating user status');
    }
  };

  return (
    <DialogBox
      title='Confirmation'
      body={`Are you sure you want to ${statusSwitch} this user`}
      confirmText='Submit'
      isOpen={isOpen}
      onCancel={handleClose}
      onConfirm={handleConfirm}
      isDisableConfirm={isDisableConfirm}
    />
  );
};

export default SwitchStatusDialog;
